
import { Component, Prop, Vue, PropSync } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import { getUserAuth, updateUserAuth } from '@/api/systemset'
import { getStudySelect, getBusinessAll } from '@/api/common/common'
import { getSchoolList } from '@/api/baseinformation'
import util from '@/utils/busi/util'

@Component({
  name: 'grant',
  components: {
    SimpleTable,
    DictSelect
  }
})

export default class Grant extends Vue {
  @PropSync('visible', { type: Boolean })
  private dialogVisible!: boolean

  @Prop({ type: String })
  private title!: string

  @Prop({ type: Object })
  private data!: object|any

  private btnLoading = !1

  private loading = !1

  private selecteds: any = []

  private form: any = {
    businessId: '',
    studyId: '',
    schoolName: ''
  }

  private async businessChange () {
    this.form.studyId = ''
    await getStudySelect({
      ...this.form
    }).then((res: any) => {
      this.studyData = res.object.list
    })
  }

  private columns = [{
    prop: 'schoolCode',
    label: '院校代码'
  },
  {
    prop: 'schoolName',
    label: '院校名称'
  },
  {
    prop: 'businessName',
    label: '业务类型'
  },
  {
    prop: 'studyName',
    label: '学习类型'
  }]

  private tableData = {
    list: [],
    totalCount: 0
  }

  private businessData: any[] = []

  private studyData: any[] = []

  private pagination = {
    currentPage: 1,
    pageSize: 10
  }

  private rowClick (row: any) {
    let flag = !1
    this.selecteds.map((val: any) => {
      if (row.id === val.schoolId) {
        flag = !0
      }
    })
    flag || this.selecteds.push({
      schoolId: row.id,
      schoolName: row.schoolName
    } as never)
  }

  private async close (id: any) {
    const temp = this.selecteds
    this.selecteds = temp.filter((val: any) => val.schoolId !== id)
  }

  private handleClose (done: Function) {
    this.selecteds = []
    done()
  }

  private async onSave () {
    const datas: any = []
    if (this.selecteds.length === 0) {
      this.$message.error('请选择至少一个院校')
      return
    }
    this.btnLoading = !0
    this.selecteds.map((val: any) => {
      datas.push({
        userId: this.data.userId,
        userName: this.data.userName,
        loginAccount: this.data.loginAccount,
        schoolId: val.schoolId,
        schoolName: val.schoolName
      } as never)
    })
    await updateUserAuth(datas as any).then((res: any) => {
      this.btnLoading = !1
      if (res.code === 10000) {
        this.$message(res.message)
        this.dialogVisible = !1
      } else {
        this.$message.error(res.message)
      }
    }).catch((err: any) => {
      console.log('err', err)
      this.btnLoading = !1
    })
  }

  private open () {
    this.form = {
      businessId: '',
      studyId: '',
      schoolName: ''
    }
    this.initAuthInfo()
    this.initQueryData()
    this.onQuery({
      currentPage: 1,
      pageSize: 10
    })
  }

  private onReset () {
    this.form = {
      businessId: '',
      studyId: '',
      schoolName: ''
    }
    this.onQuery({
      currentPage: 1,
      pageSize: 10
    })
  }

  private async onQuery (pagination: any = null) {
    this.loading = !0
    const form = util.trimForm({ ...this.form })
    form.schoolState = 1
    !pagination && (this.pagination.currentPage = 1)
    await getSchoolList({
      ...form,
      ...pagination || this.pagination
    }).then((res: any) => {
      this.loading = !1
      this.tableData.list = res.object.list
      this.tableData.totalCount = res.object.totalCount
    }).catch((err: any) => {
      console.log('err', err)
      this.loading = !1
    })
  }

  private async initAuthInfo () {
    await getUserAuth({
      loginAccount: this.data.loginAccount,
      userName: this.data.userName
    }).then((res: any) => {
      this.selecteds.length === 0 && (this.selecteds = res.object.list)
    })
  }

  private async initQueryData () {
    await getBusinessAll({
      ...this.form
    }).then((res: any) => {
      if (res.code === 10000) {
        this.businessData = res.object
      }
    })
    await getStudySelect({
      ...this.form
    }).then((res: any) => {
      if (res.code === 10000) {
        this.studyData = res.object.list
      }
    })
  }

  private roeClassName ({ row }: any) {
    const flag = this.selecteds.filter((v: any) => v.schoolId === row.id)
    return flag.length > 0 ? 'active' : ''
  }
}
